/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Project_Info_ModalInputs */

const en_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close project info modal`)
};

const fr_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre d’infos du projet`)
};

const de_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektinfo-Modal schließen`)
};

const it_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra modale delle informazioni sul progetto`)
};

const ru_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно с информацией о проекте`)
};

const es_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el modal de información del proyecto`)
};

const zh_cn2_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭项目信息模态框`)
};

const ja_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト情報モーダルを閉じる`)
};

const hi_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट जानकारी मॉडल बंद करें`)
};

const pt_pt2_close_project_info_modal = /** @type {(inputs: Close_Project_Info_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal de informações do projeto`)
};

/**
* | output |
* | --- |
* | "Close project info modal" |
*
* @param {Close_Project_Info_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_project_info_modal = /** @type {((inputs?: Close_Project_Info_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Project_Info_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_project_info_modal(inputs)
	if (locale === "de") return de_close_project_info_modal(inputs)
	if (locale === "it") return it_close_project_info_modal(inputs)
	if (locale === "ru") return ru_close_project_info_modal(inputs)
	if (locale === "es") return es_close_project_info_modal(inputs)
	if (locale === "zh-CN") return zh_cn2_close_project_info_modal(inputs)
	if (locale === "ja") return ja_close_project_info_modal(inputs)
	if (locale === "hi") return hi_close_project_info_modal(inputs)
	if (locale === "pt-PT") return pt_pt2_close_project_info_modal(inputs)
	return en_close_project_info_modal(inputs)
});